module.exports = __webpack_public_path__ + "static/img/nbg_customer.73774cf7.png";